(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("react-easy-swipe"));
	else if(typeof define === 'function' && define.amd)
		define("cheeseburger-menu", ["prop-types", "React", "react-easy-swipe"], factory);
	else if(typeof exports === 'object')
		exports["cheeseburger-menu"] = factory(require("prop-types"), require("react"), require("react-easy-swipe"));
	else
		root["cheeseburger-menu"] = factory(root["prop-types"], root["React"], root["react-easy-swipe"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 